import { Controller } from "@hotwired/stimulus"

export default class CountdownController extends Controller {
  static targets = ["band", "days", "hours", "minutes", "seconds"]
  static values  = { endsAt: String }

  declare readonly bandTarget:    HTMLElement
  declare readonly daysTarget:    HTMLElement
  declare readonly hoursTarget:   HTMLElement
  declare readonly minutesTarget: HTMLElement
  declare readonly secondsTarget: HTMLElement
  declare readonly endsAtValue:   string

  private interval: ReturnType<typeof setInterval> | null = null

  connect() {
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  private tick() {
    const diff = new Date(this.endsAtValue).getTime() - Date.now()

    if (diff <= 0) {
      this.bandTarget.classList.add("hidden")
      if (this.interval) clearInterval(this.interval)
      return
    }

    const days    = Math.floor(diff / 86_400_000)
    const hours   = Math.floor((diff % 86_400_000) / 3_600_000)
    const minutes = Math.floor((diff % 3_600_000)  / 60_000)
    const seconds = Math.floor((diff % 60_000)     / 1_000)

    this.daysTarget.textContent    = String(days).padStart(2, "0")
    this.hoursTarget.textContent   = String(hours).padStart(2, "0")
    this.minutesTarget.textContent = String(minutes).padStart(2, "0")
    this.secondsTarget.textContent = String(seconds).padStart(2, "0")
  }
}
